const AUDIT_COMMITTEE_COLUMN = [
  {
    title: 'S.No.',
    dataIndex: 'sno',
    key: 'sno',
  },
  {
    title: 'Name of Member',
    dataIndex: 'nameMember',
    key: 'nameMember',
  },
  {
    title: 'Nature of Membership',
    dataIndex: 'natureMembership',
    key: 'natureMembership',
  },
];

const AUDIT_COMMITTEE_DATA = [
  {
    key: 0,
    sno: '1.',
    nameMember: 'Mr. Abhay Deshpande Raosaheb',
    natureMembership: 'Chairman',
  },
  {
    key: 1,
    sno: '2.',
    nameMember: 'Mr. Krishna Kumar Aravamudan',
    natureMembership: 'Member',
  },
  {
    key: 2,
    sno: '3.',
    nameMember: 'Mr. Raj P Narayanam',
    natureMembership: 'Member',
  },
];

const COMPENSATION_COMMITTEE_DATA = [
  {
    key: 0,
    sno: '1.',
    nameMember: 'Mr. Krishna Kumar Aravamudan',
    natureMembership: 'Chairman',
  },
  {
    key: 1,
    sno: '2.',
    nameMember: 'Mr. Abhay Deshpande Raosaheb',
    natureMembership: 'Member',
  },
  {
    key: 2,
    sno: '3.',
    nameMember: 'Mr. Arun Vijaykumar Gupta',
    natureMembership: 'Member',
  },
];

const STAKEHOLDERS_COMMITTEE_DATA = [
  {
    key: 0,
    sno: '1.',
    nameMember: 'Mr. Arun Vijaykumar Gupta',
    natureMembership: 'Chairman',
  },
  {
    key: 1,
    sno: '2.',
    nameMember: 'Mrs Prerna Tandon',
    natureMembership: 'Member',
  },
  {
    key: 2,
    sno: '3.',
    nameMember: 'Mr. Avinash Ramesh Godkhindi',
    natureMembership: 'Member',
  },
];

const CORPORATE_SOCIAL_RESPONSIBILITY_COMMITTEE_DATA = [
  {
    key: 0,
    sno: '1.',
    nameMember: 'Mr. Raj P Narayanam',
    natureMembership: 'Chairman',
  },
  {
    key: 1,
    sno: '2.',
    nameMember: 'Mr. Abhay Deshpande Raosaheb',
    natureMembership: 'Member',
  },
  {
    key: 2,
    sno: '3.',
    nameMember: 'Mr. Avinash Ramesh Godkhindi',
    natureMembership: 'Member',
  },
];

const RISK_MANAGEMENT_COMMITTEE_DATA = [
  {
    key: 0,
    sno: '1.',
    nameMember: 'Mr. Raj P Narayanam',
    natureMembership: 'Chairman',
  },
  {
    key: 1,
    sno: '2.',
    nameMember: 'Mr. Abhay Deshpande Raosaheb',
    natureMembership: 'Member',
  },
  {
    key: 2,
    sno: '3.',
    nameMember: 'Mr. Avinash Ramesh Godkhindi',
    natureMembership: 'Member',
  },
];

export {
  AUDIT_COMMITTEE_COLUMN,
  AUDIT_COMMITTEE_DATA,
  COMPENSATION_COMMITTEE_DATA,
  STAKEHOLDERS_COMMITTEE_DATA,
  CORPORATE_SOCIAL_RESPONSIBILITY_COMMITTEE_DATA,
  RISK_MANAGEMENT_COMMITTEE_DATA,
};



// WEBPACK FOOTER //
// client/containers/StaticPages/IPO/AuditCommittee/constants.js